<template>
	<div>
		<Button type="primary" @click="addAccountButton">新增</Button>
		<Tabs value="name1">
			<TabPane label="收入" name="name1">
				<div style="width: 100% ;margin-top: 20px;">
					<Table stripe border :columns="columns" :data="incomeDatas" ref="table">
						<template slot-scope="{ row, index }" slot="action">
							<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
								@click="editAccount">编辑</Button>
							<Button type="error" size="small" :data-id="row.id" @click="delAccount">删除</Button>
						</template>
						<template slot-scope="{row, index}" slot="status">
							<i-switch v-model="incomeDatas[index].status" @on-change="saveOpen($event, index)">
								<span slot="open">开</span>
								<span slot="close">关</span>
							</i-switch>
						</template>
					</Table>
				</div>
			</TabPane>
			<TabPane label="支出" name="name2">
				<div style="width: 100% ;margin-top: 20px;">
					<Table stripe border :columns="columns" :data="outcomeDatas" ref="table">
						<template slot-scope="{ row, index }" slot="action">
							<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
								@click="editAccount">编辑</Button>
							<Button type="error" size="small" :data-id="row.id" @click="delAccount">删除</Button>
						</template>
						<template slot-scope="{row, index}" slot="status">
							<i-switch v-model="outcomeDatas[index].status" @on-change="saveOpen($event, index)">
								<span slot="open">开</span>
								<span slot="close">关</span>
							</i-switch>
						</template>
					</Table>
				</div>
			</TabPane>
		</Tabs>
		<!-- 提现申请 -->
		<Modal v-model="modal" width="500" title="类别信息">
			<Form :label-width="120">
				<FormItem label="类型名称">
					<Input placeholder="类型名称" v-model="accountForm.classname"></Input>
				</FormItem>
				<FormItem label="类型">
					<Select v-model="accountForm.classtype">
						<Option  value="1" >收入</Option>
						<Option  value="2" >支出</Option>
					</Select>
				</FormItem>
				<FormItem label="备注">
					<Input placeholder="备注" v-model="accountForm.remark"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="accountEditSubmit">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		addClassType,
		getClassTypeList,
		getClassType,
		delClassType
	} from "../../api/financeManage";

	export default {
		name: "AccountStatic",
		props: ['clickTabValue'],
		components: {

		},
		data() {
			return {
				modal: false,
				name: '',
				timePeriod: '0',
				timePeriodDate: [],
				incomeDatas: [],
				outcomeDatas: [],
				accountForm: {
					account_id: '',
					uid: '',
					account_name: '',
					remark: '',
					account_src: [],
				},
				CreateCostModal: false,
				columns: [{
						"title": "序号",
						type: 'index',
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "类型名称",
						"key": "classname",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "备注",
						"key": "remark",
						"align": "center",
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.search();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
			},
			saveOpen(e, index) {
				console.log(e)
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveAccountStatusOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getClassTypeList(that, data);
				that.incomeDatas = res.data.incomeType;
				that.outcomeDatas = res.data.outcomeType;
			},
			// 编辑账户
			async editAccount(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getAccount(that, data);
				console.log(res)
				if (res.code == 1) {
					that.accountForm = res.data.item;
					that.modal = true;
				}
			},
			// 删除账户
			delAccount(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delAccount(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			addAccountButton() {
				this.accountForm = {};
				this.modal = true;
			},
			async accountEditSubmit() {
				let that = this;
				let data = {
					token: that.token,
					accountForm: that.accountForm,
				};
				let res = await addClassType(that, data);
				if (res.code == 1) {
					this.modal = false;
					this.getList();
				}
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>